import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      sendMessage: 'zopim/message/sendMessage',
    }),

    /**
     * Automatically sends special-message to show link button that will redirect user into some particular page
     * @command - [show] <message> [/show]
     * @param {object} param
     * @param {string} param.linkType - example: 'bayar-tempo' | 'change-phone-number'
     */
    showLinkButton({ linkType = '' }) {
      const typeMapping = {
        'bayar-tempo': {
          text: 'Ajukan lagi Bayar Tempo',
          path: '/bayar-tempo',
        },
        'change-phone-number': {
          text: 'Form Penggantian Nomor Telepon',
          path: '/ubah-nomor',
        },
      };
      const { origin } = window.location;
      const selectedText = typeMapping[linkType].text;
      const selectedPath = typeMapping[linkType].path;
      const destinationUrl = `${origin}${selectedPath}`;
      const finalResponse = `[special-message] { "type": "url", "text": "${selectedText}", "url": "${destinationUrl}" }`;
      this.$zopim.sendChatMsg(finalResponse);
      this.sendMessage({
        msg: finalResponse,
        nick: 'agent:trigger', // impersonate Acha Bot
        displayName: 'Acha',
      });
    },
  },
};
